<h2>Update Objects</h2>
<form *dynamicFormInfo="formInfo">
  <div mat-dialog-content>
    <!-- Enable when other queues are added that allows users to update object status -->
    <!-- <div class="row">
      <div class="col">
        <app-generic-input
          controlName="objectStatusId"
        ></app-generic-input>
      </div>
    </div> -->

    <div class="row">
      <div class="col">
        <app-select-input
          [fetchData]="workAssignees$"
          controlName="assignedToSystemUserId"
          placeholder="Supervisor"
        ></app-select-input>
      </div>
    </div>
  </div>
</form>

<div mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    (click)="cancel()"
    data-automation-id="modal-cancel-button"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    color="warn"
    aria-label="Update Work Request"
    (click)="update()"
    data-automation-id="modal-save-button"
  >
    Save
  </button>
</div>
